import React from 'react';

function Navbar() {
  return (
    <div id="navbar">
      {/* Navbar */}
      <div className="appTitleContainer">
        <h1 className="appTitle">Heroes Evolved Item Builder <span className="appVersion">version 1.0</span></h1>
      </div>
    </div>
  )
}

export default Navbar;